/**
 * 班级卡片
 */
export default {
  groupBuy: 'グループ購入',
}
